export default defineNuxtRouteMiddleware(to => {
  const revolugoUrl = useRuntimeConfig().public.REVOLUGO_WEBSITE_URL

  if (to.path === '/') {
    return navigateTo(revolugoUrl)
  }

  return undefined
})
